<template>
    <div class="composer row" @mouseleave="showEmojiBox = false">
        <form
            @submit.prevent="send"
            @keyup.enter="send"
            class="col-12 p-4"
            style="bottom: 0; position: absolute"
        >
            <div class="float-right pt-1">
                <i
                    title="Adicionar anexo"
                    @click="$bvModal.show('modal-demanda-upload')"
                    class="mdi mdi-attachment mdi-18px cursor-pointer"
                ></i>
                <i
                    @click="showEmojiBox = !showEmojiBox"
                    class="mdi mdi-emoticon-outline cursor-pointer"
                ></i>
                <Picker
                    v-if="showEmojiBox"
                    :data="emojiIndex"
                    set="twitter"
                    @select="showEmoji"
                    :i18n="i18n"
                    :style="{
                        position: 'absolute',
                        bottom: '120px',
                        right: '20px',
                    }"
                />
            </div>
            <textarea
                v-model="message"
                placeholder="Mensagem"
                class="form-control col-12"
                ref="textarea"
                @click="showEmojiBox = false"
                @keypress="$emit('writing')"
                @mouseleave="$emit('stop-writing')"
            />
        </form>
        <ModalUpload :demanda="demanda" @completed="$emit('completed')" />
    </div>
</template>

<script>
import data from "emoji-mart-vue-fast/data/all.json";
import "emoji-mart-vue-fast/css/emoji-mart.css";
import { Picker, EmojiIndex } from "emoji-mart-vue-fast";
import ModalUpload from "./ModalUpload";
let emojiIndex = new EmojiIndex(data);
export default {
    props: ["demanda"],
    components: { Picker, ModalUpload },
    data() {
        return {
            message: "",
            showEmojiBox: false,
            emojiIndex: emojiIndex,
            emojisOutput: "",

            i18n: {
                search: "Buscar",
                notfound: "Emoji não encontrado",
                categories: {
                    search: "Procurar Resultados",
                    recent: "Usado frequentemente",
                    smileys: "Smileys e emoticon",
                    people: "Pessoas e corpo",
                    nature: "Animais e natureza",
                    foods: "Comida e bebida",
                    activity: "Atividade",
                    places: "Viagem e lugares",
                    objects: "Objetos",
                    symbols: "Símbolos",
                    flags: "Bandeiras",
                    custom: "Personalizada",
                },
            },
        };
    },
    methods: {
        send() {
            if (this.message != "" && this.message != "\n") {
                this.$emit("send", this.message);
                this.$emit("stop-writing");
                this.message = "";
            }
        },
        showEmoji(emoji) {
            let textarea = this.$refs.textarea;
            let cursorPosition = textarea.selectionStart;
            this.emojisOutput = emoji.native;

            this.message =
                this.message.substring(0, cursorPosition) +
                this.emojisOutput +
                this.message.substring(cursorPosition, this.message.length);
        },
    },
};
</script>

<style lang="css" scoped></style>
